import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type {
  CustomerMailerFilters,
  CustomerMailerSlice,
} from "./customerMailersTypes.ts";

const initialState: CustomerMailerSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "customerName",
    order: "asc",
  },
};

export const customerMailersSlice = createSlice({
  name: "customerMailers",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<CustomerMailerSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<CustomerMailerSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [
          filterType: keyof CustomerMailerFilters,
          filterValue: string | undefined,
        ]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<CustomerMailerSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  customerMailersSlice.actions;

export const selectPage = (state: RootState) => state.customerMailers.page;

export const selectRowsPerPage = (state: RootState) =>
  state.customerMailers.rowsPerPage;

export const selectFilter = (state: RootState) => state.customerMailers.filter;

export const selectSort = (state: RootState) => state.customerMailers.sort;

export default customerMailersSlice.reducer;
